/* eslint-disable*/
import {
  Grid,
  TextField,
  withStyles,
  MenuItem,
  Button,
  Divider,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "./style";
import { CircularProgress } from "../../utility/ui";
import OrchidsLogo from "../../assets/orchidsLogo.png";
import ThumbsUp from "../../assets/thumbsup.png";
import ErrorIcon from "../../assets/error.png";
import { useAlert } from "../../utility/customHooks";
import urls from "../../urls";
import FormEnquiry from "./formEnquiry";

const EnquiryExternal = ({ classes, history }) => {
  const [branchId, setBranchId] = useState("");
  const [academicYear, setAcademicYear] = useState("");
  const [academicYearList, setAcademicYearList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [contactNo, setContactNo] = useState("");
  const [maxRange, setMaxRange] = useState(0);
  const [leadData, setLeadData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [formDataObj, setFormDataObj] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const [sourceList, setSourceList] = useState([]);
  const [formType, setFormType] = useState("");

  const alert = useAlert();

  const getSource = () => {
    setLoading(true);
    fetch(`${urls.ContactSourceQrListAPIView}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setSourceList(data);
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  useEffect(() => {
    getSource();
  }, []);

  const countryCodeArray = [
    {
      value: "+91",
    },
    {
      value: "+243",
    },
    {
      value: "+966",
    },
    {
      value: "+353",
    },
    {
      value: "+230",
    },
    {
      value: "+1",
    },
    {
      value: "+968",
    },
    {
      value: "+7",
    },
    {
      value: "+65",
    },
    {
      value: "+971",
    },
    {
      value: "+44",
    },
    {
      value: "+84",
    },
    {
      value: "+49",
    },
    {
      value: "+60",
    },
    {
      value: "+81",
    },
    {
      value: "+61",
    },
    {
      value: "+965",
    },
    {
      value: "+974",
    },
  ];

  useEffect(() => {
    const branch_id = new URLSearchParams(location.search).get("branch");
    try {
      setBranchId(window.atob(branch_id));
      if (window.atob(branch_id) === "") {
        setFirstRender(false);
      }
    } catch {
      setBranchId("");
      setFirstRender(false);
    }
  }, []);

  useEffect(() => {
    if (branchId && branchList.length) {
      const filteredBranch = branchList.filter(
        (item) => item.id === parseInt(branchId)
      ).length;
      setFirstRender(false);
      if (!filteredBranch) {
        setBranchId("");
      }
    }
  }, [branchList, branchId]);

  useEffect(() => {
    if (countryCode === "+91") {
      setMaxRange(10);
    } else if (countryCode === "+243") {
      setMaxRange(9);
    } else if (countryCode === "+1") {
      setMaxRange(10);
    } else if (countryCode === "+7") {
      setMaxRange(10);
    } else if (countryCode === "+230") {
      setMaxRange(8);
    } else if (countryCode === "+353") {
      setMaxRange(9);
    } else if (countryCode === "+966") {
      setMaxRange(9);
    } else if (countryCode === "+968") {
      setMaxRange(8);
    } else if (countryCode === "+65") {
      setMaxRange(8);
    } else if (countryCode === "+971") {
      setMaxRange(13);
    } else if (countryCode === "+44") {
      setMaxRange(11);
    } else if (countryCode === "+84") {
      setMaxRange(11);
    } else if (countryCode === "+49") {
      setMaxRange(11);
    } else if (countryCode === "+60") {
      setMaxRange(10);
    } else if (countryCode === "+61") {
      setMaxRange(9);
    } else if (countryCode === "+81") {
      setMaxRange(10);
    } else if (countryCode === "+965") {
      setMaxRange(8);
    } else if (countryCode === "+974") {
      setMaxRange(8);
    }
  }, [countryCode]);

  const getBranch = () => {
    setLoading(true);
    fetch(`${urls.branches}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setBranchList(data);
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  const getAcademicYear = () => {
    setLoading(true);
    fetch(`${urls.academicYear}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setAcademicYearList(data);
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  const CreateEnquiryFun = (id) => {
    setLoading(true);
    fetch(`${urls.leadInfoFilter}?id=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
         "X-DTS-SCHEMA": urls.xdtsHost,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setFormDataObj(data[0]);
        setSelectedId(id);
        setShowForm(true);
        setFormType("Update");
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  const getLeadsSearch = () => {
    setLoading(true);
    const code = countryCode.slice(1);
    fetch(
      `${urls.leadSearchByQrCodeAPI}?academic_session=${academicYear}&enquiry=${contactNo}&country_code_primary=${code}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
           "X-DTS-SCHEMA": urls.xdtsHost,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setIsSearch(true);
        setLeadData(data);
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  useEffect(() => {
    getAcademicYear();
    getBranch();
  }, []);

  useEffect(() => {
    if (academicYearList && academicYearList.length > 0) {
      const acad = academicYearList.filter((year) => year.default);
      setAcademicYear(acad && acad.length ? acad[0].session_year : "");
    }
  }, [academicYearList]);

  let circularProgress = null;
  if (loading) {
    circularProgress = <CircularProgress open />;
  }

  function check() {
    if (!countryCode) {
      alert.warning("Select Country Code");
      setMaxRange(0);
    }
  }

  const searchHandler = () => {
    if (!academicYear || !contactNo) {
      alert.warning("Select All Fields");
      return;
    }
    if (countryCode === "+91") {
      if (contactNo.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+243") {
      if (contactNo.length !== 9) {
        alert.warning("Phone No. should be of 9 digits");
        return;
      }
    } else if (countryCode === "+1") {
      if (contactNo.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+966") {
      if (contactNo.length !== 9) {
        alert.warning("Phone No. should be of 9 digits");
        return;
      }
    } else if (countryCode === "+230") {
      if (contactNo.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+353") {
      if (contactNo.length !== 9) {
        alert.warning("Phone No. should be of 9 digits");
        return;
      }
    } else if (countryCode === "+7") {
      if (contactNo.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+968") {
      if (contactNo.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+65") {
      if (contactNo.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+971") {
      if (contactNo.length !== 9) {
        alert.warning("Phone No. should be of 9 digits");
        return;
      }
    } else if (countryCode === "+44") {
      if (contactNo.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+84") {
      if (contactNo.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+49") {
      if (contactNo.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+60") {
      if (contactNo.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+61") {
      if (contactNo.length !== 9) {
        alert.warning("Phone No. should be of 9 digits");
        return;
      }
    } else if (countryCode === "+81") {
      if (contactNo.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+965") {
      if (contactNo.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+974") {
      if (contactNo.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    }
    getLeadsSearch();
  };

  const handleSubmit = (data) => {
    // alert('handle submit hit..................');
    const formData = { ...formDataObj, ...data };
    setFormDataObj((c) => ({ ...c, ...data }));
    const obj = {
      id: +selectedId,
      academic_year:
        formData && formData.academic_year ? formData.academic_year : "",
      branch: formData && formData.branch ? formData.branch : "",
      address_details:
        formData && formData.address_details ? formData.address_details : "",
      contact_source:
        (formData && formData.contact_source && formData.contact_source.id) ||
        "",
      // concession: formData && formData.concession,
      // contact_source: (formData && formData.contact_source) || "",
      // percentage: formData && formData.concession_ammount ? formData.concession_ammount : '',
      // concession_remarks: formData && formData.concession_remarks
      // ? formData.concession_remarks : '',
      // concession_type: formData && formData.concession_type ? formData.concession_type : '',
      // previues details
      // is_branch_walkin: formData.is_branch_walkin,
      lead_name: formData && formData.lead_name ? formData.lead_name : "",
      lead_email_id:
        formData && formData.lead_email_id ? formData.lead_email_id : "",
      lead_contact_no:
        formData && formData.lead_contact_no ? formData.lead_contact_no : "",
      lead_alternateNo:
        formData && formData.lead_alternateNo ? formData.lead_alternateNo : "",
      country_code_alternate:
        formData && formData.country_code_alternate
          ? formData.country_code_alternate
          : "",
      country_code_primary:
        formData && formData.country_code_primary
          ? formData.country_code_primary
          : "",
      lead_address:
        formData && formData.lead_address ? formData.lead_address : "",
      google_latitude: formData && formData.google_latitude,
      google_longitude: formData && formData.google_longitude,
      google_address: formData && formData.google_address,
      // lead_enq_Date: formData && formData.date ? formData.date : "",
      // previues details
      // new child data
      child_detail_fk:
        formData &&
        formData.new_child &&
        formData.new_child.length !== 0 &&
        formData.new_child.map((sibChild) => ({
          id: sibChild.id || null,
          // admission_type:
          //   formData && formData.admission_type ? formData.admission_type : "",
          child_name:
            sibChild && sibChild.child_name ? sibChild.child_name : "",
          child_gender:
            sibChild && sibChild.child_gender ? sibChild.child_gender : "",
          Date_of_birth:
            sibChild && sibChild.Date_of_birth ? sibChild.Date_of_birth : "",
          child_class:
            sibChild && sibChild.child_class.id ? sibChild.child_class.id : "",
          // previus details
          // child_previous_class_percentage:
          //   sibChild && sibChild.child_previous_class_percentage
          //     ? sibChild.child_previous_class_percentage
          //     : "",
          // previous_board:
          //   sibChild && sibChild.previous_board ? sibChild.previous_board : "",
          // child_previous_school:
          //   sibChild && sibChild.child_previous_school
          //     ? sibChild.child_previous_school
          //     : "",
          // reason_for_leaving_school:
          //   sibChild && sibChild.reason_for_leaving_school
          //     ? sibChild.reason_for_leaving_school
          //     : "",
          // child_previous_class:
          //   sibChild.child_previous_class && sibChild.child_previous_class.id
          //     ? sibChild.child_previous_class.id
          //     : "",
          // pre_school_tieup:
          //   sibChild && sibChild.others
          //     ? sibChild.others
          //     : sibChild.pre_school_tieup && sibChild.pre_school_tieup.id,
        })),
    };
    // new child data
    setLoading(true);
    fetch(urls.updateLeadDetailsFromQrCode, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
         "X-DTS-SCHEMA": urls.xdtsHost,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.status_code === 200) {
          setShowForm(false);
          setShowSuccess(true);
          setContactNo("");
          setLeadData([]);
          setIsSearch(false);
          setFormType("");
          setSelectedId("");
          setFormDataObj({});
        } else {
          alert.error(data.description);
        }
      })
      .catch(() => {
        setLoading(false);
        alert.error("Failed To Complete Action");
      });
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        style={{ height: "100vh" }}
      >
        {!firstRender ? (
          branchId ? (
            <>
              {showForm ? (
                <>
                  <FormEnquiry
                    branchId={branchId}
                    branchList={branchList}
                    academicYearList={academicYearList}
                    selectedYear={academicYear}
                    countryCodeArray={countryCodeArray}
                    newContact={contactNo}
                    history={history}
                    studentdata={formDataObj}
                    submitDetails={handleSubmit}
                    countryCodePrimary={countryCode}
                    sourceList={sourceList}
                    formType={formType}
                  />
                </>
              ) : showSuccess ? (
                <>
                  <Grid item md={6} xs={10} sm={8} lg={4}>
                    <Grid
                      container
                      // spacing={1}
                      alignItems="center"
                      justifyContent="center"
                      className={classes.paper}
                      style={{
                        backgroundColor: "white",
                        borderColor: "#DCDCDC",
                        padding: "10px 20px",
                        margin: "20px 0px",
                      }}
                    >
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="center"
                        >
                          <img
                            src={ThumbsUp}
                            alt="image1"
                            style={{
                              objectFit: "cover",
                              marginBottom: 10,
                              height: 150,
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="h3" style={{ color: "green" }}>
                            Successfully Submitted Form
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ textAlign: "center", marginTop: 20 }}
                      >
                        <Button
                          color="primary"
                          size="small"
                          variant="contained"
                          onClick={() => {
                            setShowSuccess(false);
                          }}
                          style={{ width: 120 }}
                        >
                          Home
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Grid item md={6} xs={10} sm={8} lg={4}>
                  <Grid
                    container
                    // spacing={1}
                    alignItems="center"
                    justifyContent="center"
                    className={classes.paper}
                    style={{
                      backgroundColor: "white",
                      borderColor: "#DCDCDC",
                      padding: "10px 20px",
                      margin: "20px 0px",
                    }}
                  >
                    <Grid item xs={12} md={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                      >
                        <img
                          src={OrchidsLogo}
                          alt="image1"
                          style={{ objectFit: "cover", marginBottom: 10 }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        label="Academic Year"
                        margin="dense"
                        onChange={(e) => {
                          setAcademicYear(e.target.value);
                          setIsSearch(false);
                        }}
                        fullWidth
                        required
                        select
                        value={academicYear}
                      >
                        {academicYearList &&
                          academicYearList.map((type) => (
                            <MenuItem
                              value={type.session_year}
                              key={type.id}
                              name={type.session_year}
                            >
                              {type.session_year ? type.session_year : ""}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={3} sm={2} md={2}>
                          <TextField
                            margin="dense"
                            label="&nbsp;"
                            onChange={(e) => {
                              setCountryCode(e.target.value);
                              setIsSearch(false);
                            }}
                            fullWidth
                            select
                            value={countryCode}
                          >
                            {countryCodeArray &&
                              countryCodeArray.map((data) => (
                                <MenuItem
                                  value={data.value}
                                  key={data.value}
                                  name={data.value}
                                >
                                  {data.value ? data.value : ""}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={9} sm={10} md={10}>
                          <TextField
                            id="mobile"
                            label="Mobile"
                            className={classes.numberTextField}
                            margin="dense"
                            type="number"
                            onKeyDown={(e) => {
                              ["e", "E", "+", "-", "."].includes(e.key) &&
                                e.preventDefault();
                            }}
                            InputProps={{ inputProps: { min: 0 } }}
                            required
                            fullWidth
                            disabled={!maxRange}
                            onChange={(e) =>
                              e.target.value.length <
                                parseInt(maxRange + 1, 10) &&
                              setContactNo(e.target.value)
                            }
                            onClick={check}
                            value={contactNo}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Button
                          color="primary"
                          size="small"
                          variant="contained"
                          onClick={searchHandler}
                          style={{ width: 150, marginTop: 15 }}
                        >
                          Search
                        </Button>
                      </Grid>
                    </Grid>
                    {isSearch ? (
                      <>
                        {!leadData.length ? (
                          <Grid item xs={12} md={12}>
                            <Divider className={classes.divider} />
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="center"
                              direction="column"
                              spacing={1}
                            >
                              <Grid item>
                                <Typography variant="h5">
                                  Click on Enquiry Form
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Button
                                  color="primary"
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    setShowForm(true);
                                    setFormType("Add");
                                  }}
                                  style={{ width: 150 }}
                                >
                                  Enquiry Form
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid item xs={12} md={12}>
                            <Divider className={classes.divider} />
                            <Grid
                              container
                              alignItems="center"
                              direction="column"
                              spacing={1}
                            >
                              <Grid
                                item
                                xs={12}
                                style={{ textAlign: "center" }}
                              >
                                <Typography variant="h5">Details</Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Grid
                                  container
                                  direction="row"
                                  alignItems="flex-start"
                                  spacing={1}
                                >
                                  <Grid item md={4} xs={4}>
                                    <Typography variant="h6">
                                      Parent Name
                                    </Typography>
                                  </Grid>
                                  <Grid item md={8} xs={8}>
                                    <Typography variant="h6">
                                      : &nbsp;{leadData[0].lead_name}
                                    </Typography>
                                  </Grid>
                                  <Grid item md={4} xs={4}>
                                    <Typography variant="h6">
                                      Contact No.:
                                    </Typography>
                                  </Grid>
                                  <Grid item md={8} xs={8}>
                                    <Typography variant="h6">
                                      : &nbsp;{leadData[0].lead_contact_no}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                style={{ textAlign: "center" }}
                              >
                                <Button
                                  color="primary"
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    CreateEnquiryFun(leadData[0].id);
                                  }}
                                  style={{ width: 150 }}
                                >
                                  Update Form
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </>
                    ) : null}
                  </Grid>
                </Grid>
              )}
            </>
          ) : (
            <>
              <Grid item md={6} xs={10} sm={8} lg={4}>
                <Grid
                  container
                  // spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  className={classes.paper}
                  style={{
                    backgroundColor: "white",
                    borderColor: "#DCDCDC",
                    padding: "10px 20px",
                    margin: "20px 0px",
                  }}
                >
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center">
                      <img
                        src={ErrorIcon}
                        alt="image1"
                        style={{
                          objectFit: "cover",
                          marginBottom: 10,
                          height: 150,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center">
                      <Typography variant="h3" style={{ color: "red" }}>
                        Not a Valid Url
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )
        ) : null}
      </Grid>
      {circularProgress}
    </>
  );
};

export default withStyles(styles)(EnquiryExternal);
